import actionCreator from "../shared/services/actionCreator";

export const userGetAction = actionCreator("userGetAction");
export const userUpdateAction = actionCreator("userUpdateAction");
export const userLocalUpdateAction = actionCreator("userLocalUpdateAction");
export const userAuthedAction = actionCreator("userAuthedAction");
export const userCancelAction = actionCreator("userCancelAction");
export const userOrgSetAction = actionCreator("userOrgSetAction");
export const userRefreshAction = actionCreator("userRefreshAction");
